export function renderIf(condition, element) {
  if (condition) {
    return element;
  } else {
    return null;
  }
}
export function renderIfElse(condition, element1, element2) {
  if (condition) {
    return element1;
  } else {
    return element2;
  }
}
export function isFunction(callback) {
  if (typeof callback === 'function') {
    return true;
  } else {
    return false;
  }
}
